<template>
  <div id="pageTable">
    <v-dialog v-model="cropModal" persistent max-width="400">
        <v-card>
            <v-toolbar dark color="orange">
                <v-toolbar-title>EDIT PHOTO</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="cropModal=false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <div class="layout column zooming-slide-div">
                    <div class="flex">
                        <v-slider append-icon="zoom_in"
                            prepend-icon="zoom_out"
                            @click:append="zoomIn"
                            @click:prepend="zoomOut" 
                            placeholder="step" 
                            color="#ff812b" 
                            :max="2" 
                            :min="0.1" 
                            step="0.1" 
                            ticks 
                            v-model="zooming"></v-slider>
                    </div>
                </div>
                <div class="flex" id="on-wheel">
                    <clipper-fixed ref="clipper" class="basic lg" v-model="src" :src="src" bg-color="black" :round="true" preview="fixed-preview" shadow="rgba(0,0,0,0)"></clipper-fixed>
                </div>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" class="white-text" small @click="cropModal=false">DELETE</v-btn>
                <v-btn color="green white--text" class="white-text" small @click="getResult">SAVE IMAGE</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-container grid-list-xl fluid paddingZero>
      <v-layout wrap class="custom-mb">
        <v-flex xs12 ma-0 pa-0>
          <v-card color="orange">
            <div class="bg_profile"></div>
            <div class="profiletop">
              <v-card-text class="px-0">
                <v-avatar class="mx-auto d-block" size="220"> <img alt="Profile Image" title="Profile Image" :src="src_display" :style="{ width: defaultProfilePicWidth }"/>
                  <input type="file" @change="upload($event)" alt="Profile Image" title="Profile Image">
                  <span>
                  <v-icon>fa-camera</v-icon>
                  </span> </v-avatar>
                <v-card-text class="text-xs-center profileTitle">
                  <h4 v-if="!EditForm"> <a class="title-link-text" :href="discourseForumProfileUrl" target="_blank"> {{utils.getTitleCase(form.first_name)}} {{utils.getTitleCase(form.last_name)}} </a> </h4>
                  <p class="card-description "> {{!displayForm.company_state && !displayForm.company_city ? notProvidedStr : ''}}
                    {{displayForm.company_city ? displayForm.company_city+',':''}} {{displayForm.company_state ? displayForm.company_state : ''}} </p>
                </v-card-text>
              </v-card-text>
            </div>
          </v-card>
        </v-flex>
        <template v-if="!EditForm">
          <v-flex xs12 md6  ma-0 pa-0>
            <v-card color="transparent" class="vcard-position">
              <div class="custompadding20">
                <v-card-text>
                  <v-layout wrap v-if="userData.data">
                    <v-flex xs12 >
                    
                    <div class="pindiv" v-if="!userStore.user.isImr">
                      <strong> Pin: </strong> <span class="pin-text">{{showpin ? pin_no : '****'}}</span>
                        <span v-if="!showpin" @click="showpin=true"><v-icon>visibility</v-icon></span>
                      </div>
                    
                     <span class="editprofile">
                      <v-btn  @click="showEditForm"  color="orange darken- white--text"  small>
                        <v-icon>fa-edit</v-icon>
                        Edit Profile </v-btn>
                      </span>
                    </v-flex>
                    
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc">
                        <v-icon>business_center</v-icon>
                        <h1>Business Name:</h1>
                        <p>{{displayForm.company_name}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0 v-if="!userStore.user.isImr">
                      <div class="profileDesc"> <i class="fas fa-road"></i>
                        <h1>MC Number:</h1>
                        <p>{{displayForm.mc_number}} </p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="far fa-calendar-alt"></i>
                        <h1>Since:</h1>
                        <p>{{displayForm.since}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-globe"></i>
                        <h1>Website:</h1>
                        <p><a target="_blank" :href="displayForm.website" >{{displayForm.website}}</a></p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-map-marker-alt"></i>
                        <h1>Business Address:</h1>
                        <p> {{displayForm.company_address}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-globe"></i>
                        <h1>Social:</h1>
                        <template v-if="displayForm.linkedin_url == '' && displayForm.twitter_url == '' && displayForm.facebook_url == ''">
                            {{notProvidedStr}}    
                        </template>
                        <template v-else>
                            <p> 
                                <a v-if="displayForm.linkedin_url!=''" :href="displayForm.linkedin_url" target="_blank"><i class="fab fa-linkedin"></i></a> 
                                <a v-if="displayForm.twitter_url!=''" :href="displayForm.twitter_url" target="_blank"><i class="fab fa-twitter-square"></i></a> 
                                <a v-if="displayForm.facebook_url!=''" :href="displayForm.facebook_url" target="_blank"><i class="fab fa-facebook-square"></i></a> 
                            </p>
                        </template>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6 ma-0 pa-0>
                      <div class="profileDesc">
                        <v-icon>business_center</v-icon>
                        <h1>Business Description:</h1>
                        <p>{{displayForm.company_desc}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
            </v-card>
            <v-card>
              <div class="custompadding20 ">
                <v-card-text>
                  <v-layout wrap v-if="userData.data">
                    <v-flex xs12 ma-0 pa-0 v-if="!userStore.user.isImr">
                      <div class="profileDesc">
                        <v-icon>local_shipping</v-icon>
                        <h1>Equipment Type:</h1>
                        <p>{{displayForm.equipment_type}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 ma-0 pa-0>
                      <div class="profileDesc"> <i class="fas fa-star"></i>
                        <h1>Hobbies:</h1>
                        <p>{{displayForm.hobbies}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-card-text>
              </div>
            </v-card>
          </v-flex>
          <v-flex  xs12 md6 ma-0 pa-0>
            <div style="height:100%;min-height:400px;" id="profileMap"></div>
          </v-flex>
        </template>
        <v-flex xs12 ma-0 pa-0 v-if="EditForm">
          <v-card>
            <div class="custompadding20">
              <v-card-text>
                <v-layout wrap v-if="userData.data">
                  <v-flex xs12  md6>
                    <v-text-field label="First Name" v-model="form.first_name" data-vv-name="first_name" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('first_name')" required data-vv-as="First Name"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6>
                    <v-text-field label="Last Name" v-model="form.last_name" data-vv-name="last_name" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('last_name')" required data-vv-as="Last Name"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer">
                    <v-text-field label="Business Name" v-model="form.company_name" data-vv-name="company_name" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('company_name')" required data-vv-as="Business Name"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer && !userStore.user.isImr">
                    <v-text-field label="MC Number" v-model="form.mc_number" data-vv-name="mc_number" placeholder="" required data-vv-as="MC Number"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer">
                    <v-text-field label="Since" v-validate="{'digits':4,'restrictedWord':[]}" v-model="form.since" data-vv-name="since" placeholder="" :error-messages="errors.collect('since')" required data-vv-as="Since"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer">
                    <v-text-field label="http://www.google.com" v-validate="{'url':true,'restrictedWord':[]}" v-model="form.website" data-vv-name="website" placeholder="" :error-messages="errors.collect('website')" required data-vv-as="Website"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer">
                    <v-text-field label="Business Address" autocomplete="off" class="white-placeholder" v-model="form.company_address" v-validate="{company_address: [hidden_company_address]}" id="company_address" data-vv-name="company_address" data-vv-as="Business Address" placeholder="" :error-messages="errors.collect('company_address')" @input="getAddressData('company_address')"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer">
                    <v-textarea label="Business Description" v-model="form.company_desc" data-vv-name="company_desc" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('company_desc')" required data-vv-as="Business Description"> </v-textarea>
                    <input :type="'hidden'" v-model="hidden_company_address" ref="hidden_company_address" data-vv-name="hidden_company_address">
                  </v-flex>
                  <v-flex xs12  md6 v-if="editFormPer && !userStore.user.isImr">
                    <v-text-field label="Equipment Type" v-model="form.equipment_type" data-vv-name="equipment_type" placeholder="" :error-messages="errors.collect('equipment_type')" required data-vv-as="Equipment Type"> </v-text-field>
                  </v-flex>
                  <v-flex xs12 md6>
                    <v-text-field label="Hobbies" v-model="form.hobbies" data-vv-name="hobbies" placeholder="" v-validate="{'restrictedWord':[]}" :error-messages="errors.collect('hobbies')" required data-vv-as="Hobbies"> </v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field label="LinkedIn URL: (Example: http://www.linkedin.com)" v-validate="{url: {require_protocol: true },'restrictedWord':[]}" v-model="form.linkedin_url" data-vv-name="linkedin_url" placeholder="" :error-messages="errors.collect('linkedin_url')" data-vv-as="Linkedin URL"> </v-text-field>
                  </v-flex>
                  <v-flex xs12 md12>
                    <v-text-field label="Twitter URL: (Example: http://www.twitter.com)" v-validate="{url: {require_protocol: true },'restrictedWord':[]}" v-model="form.twitter_url" data-vv-name="twitter_url" placeholder="" :error-messages="errors.collect('twitter_url')" data-vv-as="Twitter URL"> </v-text-field>
                  </v-flex>
                  <v-flex xs12  md12>
                    <v-text-field label="Facebook URL: (Example: http://www.facebook.com)" v-validate="{url: {require_protocol: true },'restrictedWord':[]}" v-model="form.facebook_url" data-vv-name="facebook_url" placeholder="" :error-messages="errors.collect('facebook_url')" data-vv-as="Facebook URL"> </v-text-field>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <div class="form-btn text-xs-right">
                <v-btn color="gray  white--text" @click="hideEditForm">
                  <v-icon color="white">fa-times-circle</v-icon>
                  Cancel</v-btn>
                <v-btn color="green white--text" @click="submitForm"> Save </v-btn>
              </div>
            </div>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import services from "../services/HttpService";
import breadcrumbs from "./widgets/Breadcrumb";
import GoogleAds from "@/pages/widgets/GoogleAds";
import {
    clipperBasic,
    clipperPreview,
    clipperUpload,
    clipperFixed
} from 'vuejs-clipper'
import axios from "axios";
import {
    ErrorBag
} from 'vee-validate';
import config from "../config";
import {
    Validator
} from 'vee-validate';
import {
    mapGetters,
    mapActions
} from "vuex";
import utils from "../util";
import { setTimeout } from 'timers';
import store from '../store/';
const ADDRESS_COMPONENTS2 = {
    subpremise: 'short_name',
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    administrative_area_level_2: 'long_name',
    country: 'long_name',
    postal_code: 'short_name'
};
Validator.extend('company_address', {
    getMessage: field => 'The ' + field + ' field is Invalid.',
    validate: function (value, [oth]) {
        if (oth == '') {
            return false;
        }
        return true;
    }
});

export default {
    $_veeValidate: {
        validator: 'new'
    },
    watch :{
        zooming(val){
            const self = this;
            self.zooming = val;
            self.$refs.clipper.setWH$.next(self.zooming)
        }
    },
    data: () => ({
        // componentKey:1,
        zooming:1,
        discourseForumProfileUrl:config.discourseForumProfileUrl,
        notProvidedStr:config.notProvidedStr,
        src_display: '',
        src: '',
        canvas: '',
        resultURL: '',
        userData: {},
        EditForm: false,
        companyProfilePer: null,
        editFormPer: false,
        hidden_company_address: '',
        imgSrc: '',
        cropImg: '',
        userStore: null,
        cropModal: false,
        showpin: false,
        pin_no: '',
        defaultProfilePicWidth:"inherit",
        form: {
            mc_number: '',
            company_name: '',
            since: '',
            website: '',
            company_address: '',
            company_desc: '',
            equipment_type: '',
            hobbies: '',
            first_name: '',
            last_name: '',
            company_country: '',
            company_state: '',
            company_city: '',
            company_latitude: '',
            company_longitude: '',
            company_zip_code: '',
            linkedin_url: '',
            twitter_url:'',
            facebook_url:''
        },
        displayForm: {
            mc_number: '',
            company_name: '',
            since: '',
            website: '',
            company_address: '',
            company_desc: '',
            equipment_type: '',
            hobbies: '',
            first_name: '',
            last_name: '',
            company_country: '',
            company_state: '',
            company_city: '',
            company_latitude: '',
            company_longitude: '',
            company_zip_code: '',
            linkedin_url: '',
            twitter_url:'',
            facebook_url:''
        },
        breadcrumbs: [{
                name: 'Dashboard',
                to: "/dashboard",
                disabled: false
            },
            {
                name: 'Reporting',
                disabled: true
            },
            {
                name: 'AutoLoader',
                disabled: true
            }
        ]
    }),
    components: {
        breadcrumbs,
        clipperBasic,
        clipperPreview,
        clipperUpload,
        clipperFixed,
        GoogleAds
    },
    mounted() {
        const self = this;
        self.$validator.localize('en', self.dictionary);
        self.companyProfilePer = this.$store.state.user.permissions.company_profile ? this.$store.state.user.permissions.company_profile : null;
        self.editFormPer = (this.$store.state.user.permissions.company_profile && this.$store.state.user.permissions.company_profile == 'all') || (this.$store.state.user.IsCompanyadmin) ? true : false;
        
        document.getElementById("on-wheel").addEventListener("wheel", function(e){
            if (e.deltaY < 0) {
                self.zooming = self.zooming + 0.1;
                self.$refs.clipper.setWH$.next(self.zooming);
            }
            if (e.deltaY > 0) {
                self.zooming = self.zooming - 0.1;
                self.$refs.clipper.setWH$.next(self.zooming);
            }
        });
        self.pin_no = self.$store.state.user.pin_no ? self.$store.state.user.pin_no : config.notProvidedStr;
        
    },
    async created() {
        const self = this,
            wApp = window.getApp;
        self.utils = utils;
        self.userStore = this.$store.state;
        // self.componentKey = self.$store.state.loginTimeStamp;
        if(self.$route.query && self.$route.query.e && self.$route.query.e==1){
            self.EditForm = true;
        }
        await self.setUserForm();
    },
    methods: {
        ...mapActions([
            "updateLoggedInName",
            "updateLoggedInCompanyAdd",
            "updateUserProfilePic"
        ]),
        zoomIn: function () {
            const self = this;
            self.zooming = self.zooming + 0.1;
            this.$refs.clipper.setWH$.next(self.zooming)
        },
        zoomOut: function () {
            const self = this;
            self.zooming = self.zooming - 0.1
            this.$refs.clipper.setWH$.next(self.zooming)
        },
        upload: function (e) {
            if (e.target.files.length !== 0) {
                if (this.src) URL.revokeObjectURL(this.src)
                this.src = window.URL.createObjectURL(e.target.files[0]);
                this.showCropperModal();
            }
        },
        getResult: function () {
            const self = this;
            const canvas = self.$refs.clipper.clip(); //call component's clip method
            self.resultURL = canvas.toDataURL("image/png", 1); //canvas->image
            if (self.resultURL) {
                self.urltoFile(self.resultURL)
                    .then(function (file) {
                        self.onFileChange(file);
                    })
            }
        },
        setUserForm: function(){
            const self = this,
            wApp = window.getApp;
            wApp.$emit("showLoader", {
                show: true
            });
            axios.all([
                services.post("users/userListById", {
                    uuid: self.$store.state.user.uuid
                }, {
                    'Authorization': 'Bearer ' + this.$store.state.user.token
                })
            ])
            .then(axios.spread(function (users) {
                self.userData = Object.assign({}, users);
                self.utils.updateLoggedInUserInfo(store,users.data.data.User);
                self.form.company_name = users.data.data.User.company_name;
                self.form.mc_number = users.data.data.User.mc_number;
                self.form.company_address = users.data.data.User.company_address;
                self.form.company_city = users.data.data.User.company_city;
                self.form.company_state = users.data.data.User.company_state;
                self.form.company_latitude = users.data.data.User.company_latitude;
                self.form.company_longitude = users.data.data.User.company_longitude;
                self.hidden_company_address = users.data.data.User.company_address;
                self.form.since = users.data.data.User.since;
                self.form.website = users.data.data.User.website;
                self.form.company_desc = users.data.data.User.company_desc;
                self.form.equipment_type = users.data.data.User.equipment_type;
                self.form.hobbies = users.data.data.User.hobbies;
                self.form.first_name = users.data.data.User.UserContacts.first_name;
                self.form.last_name = users.data.data.User.UserContacts.last_name;
                self.form.facebook_url = users.data.data.User.facebook_url;
                self.form.twitter_url = users.data.data.User.twitter_url;
                self.form.linkedin_url = users.data.data.User.linkedin_url;
                self.displayForm = Object.assign({},self.form);

                if(users.data.data.User.UserContacts.image_path != ''){
                    self.src_display = config.profileUrl + users.data.data.User.UserContacts.image_path;
                }else{
                    self.src_display = config.defaultProfilePicPath;
                    self.defaultProfilePicWidth = config.defaultProfilePicWidth+"px";
                }                
                if(self.EditForm){
                    self.showEditForm();
                }else{
                    self.getMap();
                }
                wApp.$emit("showLoader", {
                    show: false
                });

            }))
            .catch(function (err) {
                wApp.$emit("showLoader", {
                    show: false
                });
                self._showToast(err.message, "red");
            });
        },
        urltoFile: function (url) {
            let arr = url.split(','),
                mimeType = arr[0].match(/:(.*?);/)[1],
                ext = mimeType.split('/');
            return (fetch(url)
                .then(function (res) {

                    return res.arrayBuffer();
                })
                .then(function (buf) {
                    return new File([buf], 'filename.' + ext[1], {
                        type: mimeType
                    });
                })
            );
        },
        submitForm() {
            const self = this,
                wApp = window.getApp;
            self.$validator.validateAll()
                .then(isValid => {
                    if (isValid) {
                        wApp.$emit("showLoader", {
                            show: true
                        });
                        const formData = Object.assign({}, self.form);
                        formData.uuid = self.$store.state.user.uuid;
                        delete formData.UserContacts;
                        delete formData.UserRoles;
                        services.put("users/edit", formData, {
                                "Authorization": "Bearer " + this.$store.state.user.token
                            })
                            .then(res => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                if (res.data.status) {
                                    self.updateLoggedInName({
                                        name: self.form.first_name+' '+self.form.last_name
                                    });
                                    self.updateLoggedInCompanyAdd({
                                        company_address: self.form.company_address
                                    });
                                    self._showToast(res.data.message);
                                    self.hideEditForm();
                                    self.displayForm = self.form;
                                } else {
                                    self._showToast(res.data.message, "red");
                                }
                            })
                            .catch(err => {
                                wApp.$emit("showLoader", {
                                    show: false
                                });
                                self._showToast(err.message, "red");
                            });
                    }
                });
        },
        onFileChange(fileList) {
            const self = this,
                wApp = window.getApp;
            let files = new FormData();
            wApp.$emit("showLoader", {
                show: true
            });
            files.append("file", fileList);

            services.postFile("users/upload-profile", files, {
                    'content-type': 'multipart/form-data',
                    "Authorization": "Bearer " + self.$store.state.user.token
                })
                .then(res => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self.hideCropperModal();
                    if (!res.data.is_error) {
                        self._showToast(res.data.message);
                        self.fileError = null;
                        self.src = res.data.fileName;
                        self.src_display = res.data.fileName;
                        self.updateUserProfilePic({
                            userProfilePic: res.data.fileName
                        });
                    } else {
                        self._showToast(res.data.message, "red");
                        self.fileError = null;
                        self.fileError = "There is error in file at record number(s) " + res.data.defected_rows + ". Please correct it and upload file again."
                        this.files = new FormData();
                    }
                })
                .catch(err => {
                    wApp.$emit("showLoader", {
                        show: false
                    });
                    self._showToast(err.message, "red");
                });
        },
        getMap() {
            const self = this;
            // The location of Uluru
            var uluru = new google.maps.LatLng(self.displayForm.company_latitude, self.displayForm.company_longitude);
            // The map, centered at Uluru
            var map = new google.maps.Map(
                document.getElementById('profileMap'), {
                    zoom: 5,
                    center: uluru
                });
            var contentString = '<div id="content" class="MarkerLabelFontCls">' + self.displayForm.company_address + '</div>';
            var infowindow = new google.maps.InfoWindow({
                content: contentString
            });

            // The marker, positioned at Uluru
            var marker = new google.maps.Marker({
                position: uluru,
                map: map,
                icon: '/static/icon/map-marker.png',
            });
            marker.addListener('click', function () {
                infowindow.open(map, marker);
            });
        },
        _showToast(msg, color) {
            window.getApp.$emit("showSnackbar", {
                color,
                msg
            });
        },
        initAddressApi() {
            const options = {},
                self = this;
            self.origin_autocomplete2 = new google.maps.places.Autocomplete(
                document.getElementById('company_address'),
                options
            );
            self.origin_autocomplete2.setComponentRestrictions({
                'country': ['CAN', 'US']
            });
            self.origin_autocomplete2.addListener('place_changed', function () {
                let place2 = self.origin_autocomplete2.getPlace();
                if (place2.address_components !== undefined) {
                    self.formatResultCompanyAddress(place2);
                } else {
                    self.hidden_company_address = '';
                }
            });
        },
        getAddressData(data) {
            const self = this;
            self['hidden_' + data] = '';
            this.$validator.validate(data);
        },
        formatResultCompanyAddress: function (place) {
            const self = this;
            let returnData = {};
            for (let i = 0; i < place.address_components.length; i++) {
                let addressType = place.address_components[i].types[0];
                if (ADDRESS_COMPONENTS2[addressType]) {
                    let val = place.address_components[i][ADDRESS_COMPONENTS2[addressType]];
                    returnData[addressType] = val;
                }
            }
            returnData['latitude'] = place.geometry.location.lat();

            self.form['company_address'] = '';
            self.form['company_address'] = place.formatted_address;
            self['hidden_company_address'] = place.formatted_address;
            self.form['company_city'] = returnData.locality;
            self.form['company_state'] = returnData.administrative_area_level_1;
            self.form['company_country'] = returnData.country;
            self.form['company_zip_code'] = returnData.postal_code;
            self.form['company_latitude'] = place.geometry.location.lat();
            self.form['company_longitude'] = place.geometry.location.lng();
        },
        async hideEditForm() {
            const self = this;
            await self.setUserForm();
            self.EditForm = false;
            setTimeout(function () {
                self.getMap();
            }, 100)
        },
        showEditForm() {
            const self = this;
            self.EditForm = true;
            if(self.editFormPer){
                setTimeout(function () {
                    self.initAddressApi();
                }, 100);
            }
        },
        showCropperModal() {
            const self = this;
            self.cropModal = true;
            
            self.$refs.clipper.setWH$.next(0.5);
        },
        hideCropperModal() {
            const self = this;
            self.cropModal = false;
            self.src = '';
        },
    }
};
</script>
<style>
a.title-link-text {
    text-decoration: none !important;
    color:#ffffff !important;
}
.gm-style .gm-style-iw{
    color: #000000 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Profile.vue